import { error } from '@sveltejs/kit';

export async function load({ params, url, fetch }) {
    const data = await fetch(`/api/collections/${params.collection}${url.search}`);
    const json = await data.json();

    if (json?.cms?._type !== 'collection') {
        error(404, {
            message: 'Product Collection not found',
            code: 'NOT_FOUND_COLLECTION'
        });
    }

    const filters = json?.filters ?? [];
    const sortKey = json?.sortKey;

    const selectedFilters = filters.reduce((acc, item) => {
        acc[JSON.stringify(item)] = true;
        return acc;
    }, {});

    return { ...json, filters, selectedFilters, sortKey };
}
